import { useI18n } from '../i18n';

const NewStaffBadge = () => {
  const { t } = useI18n();
  return (
    <span
      className="inline-flex rounded-full bg-rose-600 px-2 py-1 text-[9px] font-bold leading-none tracking-wide text-white ring-2 ring-white"
      aria-label={t('staff.newStaff')}
    >
      NEW
    </span>
  );
};

export default NewStaffBadge;
